import { useState, useEffect } from "react";
import whatsappIcon from "@/assets/whatsapp-green-icon.png";

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const phoneNumber = "491788783369";
  const message = encodeURIComponent("Hallo, ich interessiere mich für Ihre Malerarbeiten in Herford.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3.5 rounded-lg shadow-lg transition-all duration-500 hover:translate-y-[-2px] hover:shadow-xl group ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
      style={{ backgroundColor: '#22c55e' }}
      aria-label="Kontakt per WhatsApp"
    >
      <img src={whatsappIcon} alt="WhatsApp Kontakt" className="w-5 h-5" />
      <span className="hidden md:inline font-medium text-sm text-white">Jetzt anfragen</span>
    </a>
  );
};
